import { useCallback, useState } from 'react';
import { getBookingGuestDocuments } from '../services/api';

/**
 * Shared state for opening the stay-guest (snapshot) info drawer from
 * booking detail / customer booking history.
 */
export default function useStayGuestDrawer() {
  const [open, setOpen] = useState(false);
  const [guest, setGuest] = useState(null);
  const [bookingId, setBookingId] = useState(null);
  const [bookingCode, setBookingCode] = useState('');

  const close = useCallback(() => {
    setOpen(false);
    setGuest(null);
    setBookingId(null);
    setBookingCode('');
  }, []);

  const prefetchStayGuestDocs = useCallback((stayGuest, bid) => {
    const resolvedBookingId = bid ?? stayGuest?.booking_id;
    const guestId = stayGuest?.id;
    if (!resolvedBookingId || !guestId) return;
    if (!(stayGuest.has_id_front || stayGuest.has_id_back)) return;
    getBookingGuestDocuments(resolvedBookingId, guestId).catch(() => {});
  }, []);

  const openStayGuest = useCallback(
    ({ stayGuest, bookingId: bid, bookingCode: code } = {}) => {
      if (!stayGuest) return;
      setGuest(stayGuest);
      setBookingId(bid ?? stayGuest.booking_id ?? null);
      setBookingCode(code || '');
      setOpen(true);
      prefetchStayGuestDocs(stayGuest, bid ?? stayGuest.booking_id);
    },
    [prefetchStayGuestDocs]
  );

  return {
    open,
    guest,
    bookingId,
    bookingCode,
    openStayGuest,
    close,
    setGuest,
    prefetchStayGuestDocs,
    titleOverride: bookingCode ? `Stay guest · ${bookingCode}` : 'Stay guest info',
    subtitleOverride: 'Guest details as captured for this stay. Edits apply to this booking only.',
  };
}
